import { animate, inView } from 'motion';

export const numberCounter = () => {
  const numbers = [
    {
      selector: '[k-el="num1"]',
      duration: 4.5,
      easing: 'ease',
      outcome: 10000,
      endsWith: '+',
    },
    {
      selector: '[k-el="num2"]',
      duration: 4.5,
      easing: 'ease',
      outcome: 1800,
      endsWith: '+',
      delay: 0.5,
    },
    {
      selector: '[k-el="num3"]',
      duration: 4.5,
      easing: 'ease',
      outcome: 3000,
      endsWith: '+',
      delay: 1,
    },
    {
      selector: '[k-el="num4"]',
      duration: 4.5,
      easing: 'ease',
      outcome: 96,
      endsWith: '%+',
      delay: 1.5,
    },
    {
      selector: '[k-el="num5"]',
      duration: 4.5,
      easing: 'ease',
      outcome: 95,
      endsWith: '+',
      delay: 2,
    },
    {
      selector: '[k-el="num6"]',
      duration: 4.5,
      easing: 'ease',
      outcome: 40,
      endsWith: '+',
      delay: 2.5,
    },
  ];

  numbers.forEach(({ selector, duration, easing, outcome, endsWith, delay }) => {
    const number = document.querySelector(selector) as HTMLElement;
    number.innerHTML = Math.round(0 * outcome).toLocaleString('en-US') + endsWith;
    const numberComponent = document.querySelector('[k-el="numbers"') as HTMLElement;

    inView(numberComponent, () => {
      animate(
        (progress: number) => {
          const formattedNumber = Math.round(progress * outcome).toLocaleString('en-US');
          number.innerHTML = formattedNumber + endsWith;
        },
        {
          delay,
          duration,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          easing: easing as any,
        }
      );
    });
  });
};
